// Copyright (c) 2020 Deere & Company

import { FormattedMessage } from 'react-intl';
import React from 'react';
import { createErrorMessage } from '../action-creator/alert-messages';
import store from '../../../store';

export const errorAlertBar = errorObject => {

    const { dispatch } = store;
    let { message } = errorObject;
    const { messages } = errorObject;
    // if ( !message ) message = errorObject.messages[0].message;

    if ( messages ) {

        messages.forEach( element => {

            if ( element.isTranslated || errorObject.isTranslated === undefined ) {

                message = element.message;
                dispatch( createErrorMessage( message ) );

            } else {

                dispatch( createErrorMessage( <FormattedMessage id={errorObject.message} /> ) );

            }

        } );

    } else if ( message ) {

        if ( errorObject.isTranslated || errorObject.isTranslated === undefined ) {

            dispatch( createErrorMessage( message ) );

        } else {

            dispatch( createErrorMessage( <FormattedMessage id={errorObject.message} /> ) );

        }

    } else {

        dispatch( createErrorMessage( <FormattedMessage id="UNABLE_TO_CONTACT_THE_SERVER" /> ) );

    }

};
